$(function() {

	$(":input[data-provide='datepicker']")
		.on("input", function(event) {

			var dateInput = $(event.target);

			var dateFormat = dateInput.data("date-format");
			var momentDateFormat = dateFormat.toUpperCase();
			var isValidDate = moment(dateInput.val(), momentDateFormat, true).isValid();

			if (isValidDate) {
				dateInput.datepicker("update");
				dateInput.data("datepicker")._trigger("changeDate");
			}
		});

});
